import isSameYearDF from 'date-fns/isSameYear';
import format from 'date-fns/format';

/**
 * @function formatDate
 * Utility method for formatting the date in th given format.
 *
 * @param {Date} date object to be formatted
 * @param {string} dateFormat for the date @see {@link https://date-fns.org/v2.14.0/docs/format#description}
 *
 * @returns {string} contains date in the specified format
 */
export function formatDate(date, dateFormat = 'MMM d, yyyy') {
  return format(date, dateFormat);
}

/**
 * @function isSameYear
 * Utility method for checking whether two dates are within the same year or not.
 *
 * @param {Date} dateLeft object to be compared with the other date.
 * @param {Date} dateRight object to be compared with the other date.
 *
 * @returns {boolean} two dates are within the same year or not.
 */
export function isSameYear(dateLeft, dateRight) {
  return isSameYearDF(dateLeft, dateRight);
}
